import { render, staticRenderFns } from "./pagseguro.vue?vue&type=template&id=35c8dba2&"
import script from "./pagseguro.vue?vue&type=script&lang=js&"
export * from "./pagseguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports